type Handler = (pluginElement: Element) => void

/**
 * Create an event handler that checks if the target element matches selectors in a map and calls the associated handler
 * if so.
 * @param selectorHandlerMap Map selectors to event handlers
 */
export const mapSelectorToEventHandler = (
  selectorHandlerMap: Record<string, Handler>
) => (event: Event): void => {
  const pluginElement = event.currentTarget as Element
  const eventTargetElement = event.target as Element

  Object.entries(selectorHandlerMap).forEach(([selector, handler]) => {
    if (eventTargetElement.matches(selector)) {
      handler(pluginElement)
    }
  })
}

/**
 * Add an event listener with filters
 * @param arg.target Element where the listener is added
 * @param arg.eventName Event to listen for
 * @param arg.selector Event target must match this selector for the handler to be executed
 * @param arg.handler Event handler
 * @param arg.prevent Prevents the handler to be executed when `prevent()` returns true
 */
export const addEventListener = ({
  target,
  eventName,
  selector,
  handler,
  prevent
}: {
  target: Element
  eventName: string
  selector: string
  handler: (event: Event) => void
  prevent?: () => boolean
}): void => {
  target.addEventListener(eventName, (event: Event) => {
    const eventTargetElement = event.target as Element
    if (prevent && prevent()) {
      return
    }
    if (eventTargetElement.matches(selector)) {
      handler(event)
    }
  })
}
